// extracted by mini-css-extract-plugin
export default {"socialHolder":"Cart_socialHolder__Cc16E","paypalButtonHolder":"Cart_paypalButtonHolder__GP-iR"};